import {
  LitheElement,
  LitheElementTag,
  LitheFC,
} from '@wheelbox/lithejs-engine';

import Icon from '../icon';

import { createId } from '../../../utils';

import { MessageType } from './types';

const messageTypeClasses: Record<MessageType, string> = {
  [MessageType.ERROR]: 'bg-error/10',
  [MessageType.INFO]: 'bg-info/10',
  [MessageType.REPORT]: 'bg-report/10',
  [MessageType.SUCCESS]: 'bg-success/10',
  [MessageType.WARNING]: 'bg-warning/10',
};

type MessageProps = {
  type: MessageType;
  content: LitheElement<LitheElementTag>;
};

const Message: LitheFC<MessageProps> = ({
  id = createId(),
  testId = 'message',
  type,
  content,
}) => {
  return [
    'div',
    {
      id,
      'data-testid': testId,
      class: ['p-2 flex items-center gap-4', messageTypeClasses[type]],
    },
    Icon({ icon: type, classes: 'w-5 h-5' }),
    content,
  ];
};

export default Message;
